import React, { useState } from 'react';
import { Button, Select, Space, Typography, Alert } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import {
  getPendingOnboardingCount,
  PENDING_ONBOARDING_POLICY_TAB,
} from '../orgDetailTabHelpers';
import '../orgs-dashboard.css';

const { Option } = Select;
const { Text } = Typography;

const ExportPanel = ({ tabCounts = {}, onExport, loading = false, searchApplied = false }) => {
  const [selectedExportTab, setSelectedExportTab] = useState('all');

  const activeCount = tabCounts.active?.count || 0;
  const inactiveCount = tabCounts.inactive?.count || 0;
  const pendingCount = getPendingOnboardingCount(tabCounts);
  const totalCount = activeCount + inactiveCount + pendingCount;

  const getRecordCount = () => {
    switch (selectedExportTab) {
      case 'all':
        return totalCount;
      case 'active':
        return activeCount;
      case 'inactive':
        return inactiveCount;
      case PENDING_ONBOARDING_POLICY_TAB:
        return pendingCount;
      default:
        return 0;
    }
  };

  const exportCount = getRecordCount();

  const handleExport = () => {
    if (onExport) {
      onExport(selectedExportTab);
    }
  };

  return (
    <>
      <div className="org-detail-context-strip org-export-counts">
        <div className="org-detail-chip">
          <span className="org-detail-chip__label">Active</span>
          <span className="org-detail-chip__value">{activeCount}</span>
        </div>
        <div className="org-detail-chip">
          <span className="org-detail-chip__label">Inactive</span>
          <span className="org-detail-chip__value">{inactiveCount}</span>
        </div>
        <div className="org-detail-chip">
          <span className="org-detail-chip__label">Pending onboarding</span>
          <span className="org-detail-chip__value">{pendingCount}</span>
        </div>
        <div className="org-detail-chip">
          <span className="org-detail-chip__label">Total exportable</span>
          <span className="org-detail-chip__value">{totalCount}</span>
        </div>
      </div>

      <div className="org-detail-toolbar">
        <Select
          value={selectedExportTab}
          onChange={setSelectedExportTab}
          size="small"
          className="org-export-select"
        >
          <Option value="all">All policies ({totalCount})</Option>
          <Option value="active">Active only ({activeCount})</Option>
          <Option value="inactive">Inactive only ({inactiveCount})</Option>
          <Option value={PENDING_ONBOARDING_POLICY_TAB}>
            Pending onboarding ({pendingCount})
          </Option>
        </Select>
        <Space size={8} wrap>
          <Text type="secondary" style={{ fontSize: 12 }}>
            {exportCount} record{exportCount !== 1 ? 's' : ''} selected
          </Text>
          <Button
            type="primary"
            size="small"
            icon={<DownloadOutlined />}
            onClick={handleExport}
            loading={loading}
            disabled={exportCount === 0}
          >
            Download CSV
          </Button>
        </Space>
      </div>

      {searchApplied ? (
        <Alert
          type="warning"
          showIcon
          style={{ marginBottom: 12 }}
          message="Search filter applied — export uses the search from the active/inactive policies tabs."
        />
      ) : null}

      <Text type="secondary" style={{ fontSize: 12, display: 'block' }}>
        CSV includes name, phone, email, policy number, status, package, location, and related fields. Up to 10,000 rows per export.
      </Text>
    </>
  );
};

export default ExportPanel;
